<template>
  <v-app class="bckgrnds">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
              <h3 style="text-align:center;color:#3486d7;">{{form.firstName + " " + form.lastName}}&nbsp;<span style="font-size:14px;color:black">({{form.levelName}})</span></h3>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
            <v-text-field readonly v-model="form.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
            <v-text-field readonly v-model="form.mobileNumber" label="Mobile number *" type="Number" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
              <v-text-field readonly v-model="selectedNature" label="Nature"></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3>
              <v-text-field readonly v-model="selectedSource" label="Source"></v-text-field>
          </v-flex>

          <v-flex xs12>
              <table cellspacing="0" cellpadding="0" width="100%" style="border-top:1px solid;">
                  <tr>
                      <td width="6%" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <h6 style="font-size:15px;padding-top:5px">Country</h6>
                      </td>

                      <td width="12%" v-for="data in itemAdded" :key="data.id" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <p style="padding-top:5px">{{data.countryName}}</p>
                      </td>
                  </tr>
                  <tr>
                      <td width="6%" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <h6 style="font-size:15px;padding-top:5px">University</h6>
                      </td>

                      <td width="12%" v-for="data in itemAdded" :key="data.id" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <p style="padding-top:5px">{{data.universityName}}</p>
                      </td>
                  </tr>
                  <tr>
                      <td width="6%" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <h6 style="font-size:15px;padding-top:5px">Course</h6>
                      </td>

                      <td width="12%" v-for="data in itemAdded" :key="data.id" style="text-align:center;border-right:1px solid;border-bottom:1px solid;border-left:1px solid;">
                          <p style="padding-top:5px">{{data.courseName}}</p>
                      </td>
                  </tr>
              </table>
          </v-flex>

          <v-flex xs12 v-if="form.document==true" style="padding-top:25px">
               <v-textarea readonly :auto-grow="true" v-model="form.documentType" rows="1" row-height="15" label="Details of Documents"></v-textarea>
          </v-flex>

          <v-flex xs12 style="padding-top:10px" v-if="form.notes != null">
               <v-textarea readonly outline :auto-grow="true" v-model="form.notes" rows="5" row-height="15" label="Notes"></v-textarea>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn depressed color="primary" dark @click="onEdit()">Edit </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>


    <v-card class="form-container" style="border:1px solid;margin-top:0px">
      <v-layout row wrap>
        <v-flex xs12 sm6 md6>
          <h6>Last Followup&nbsp;&nbsp;&nbsp;<span class="hvr" @click.stop="dialoghis=true" style="font-size:12px;color:#3486D7">(View Details)</span></h6>
         
         <v-layout row wrap v-if="form.followup != null"> 
           <v-flex xs8 sm8 md8>
             <v-card style="background-color:#CBCBCB;padding:8px;text-align:right;border-left: 2px solid">
            <p style="margin-top:5px;font-size:15px">Last Followup Date : &nbsp;{{form.followup.lastDate}}</p>
          </v-card>

          <v-card style="background-color:#F99420;padding:8px;margin-top:15px;border-right: 2px solid">
            <h6>Remarks :</h6>
            <p style="margin-top:5px;font-size:14px">
              {{form.followup.remarks}}
            </p>
          </v-card>

          <v-card style="background-color:#CBCBCB;padding:8px;text-align:right;border-left: 2px solid;margin-top:15px;">
            <p style="margin-top:5px;font-size:15px">Next Followup Date : &nbsp;{{form.followup.nextFollowupDate}}</p>
          </v-card>
           </v-flex>
         </v-layout>
          
        </v-flex>

        <v-flex xs12 sm6 md6 v-if="roleType=='Counsellor'">
          <v-form ref="formf" v-model="valid" lazy-validation>
            <h6>Followup</h6>
            <v-textarea outline :auto-grow="true" v-model="formf.remarks" :rules="emptyRule" required rows="5" row-height="15" label="Remarks"></v-textarea>
            <v-dialog ref="dialog" v-model="dateModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formf.nextFollowupDate"
                                label="Next followup date"
                                append-icon="event"
                                readonly
                                :rules="emptyRule"
                                required
                              ></v-text-field>
                              <v-date-picker v-model="formf.nextFollowupDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
                      <div style="text-align:right">
                            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSave()">Submit </v-btn>
                      </div>
          </v-form>
        </v-flex>

        <v-flex xs12 sm6 md6 v-if="roleType=='Administrator'">
          <v-form ref="forma" v-model="valid" lazy-validation>
            <h6>Lead Allotment</h6>
                      <v-autocomplete
                              outline
                              dense
                              v-model="selectedUser"
                              :items="user"
                              label="Select Counsellor"
                              item-text="fullName"
                              item-value="id"
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
                      <div style="text-align:right">
                            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSaveA()">Submit </v-btn>
                      </div>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialoghis" width="1000">
      <v-card>
        <div style="text-align:right;padding:5px">
          <v-icon @click.stop="dialoghis=false">cancel</v-icon>
        </div>
        <v-container style="margin-top:-15px">
          <h4 style="text-align:center;color:#3486d7;">{{form.firstName + " " + form.lastName}}&nbsp;<span style="font-size:14px;color:black">({{form.levelName}})</span></h4>
        <v-timeline>
          <v-timeline-item v-for="(followup, i) in form.followupList" :key="i" small>
            <span
              slot="opposite"
              :class="`font-weight-dark`"
              style="color:black"
            >Next followup: {{followup.nextFollowupDate}}</span>
            <div style="background-color:#F99420;padding:10px;border-radius:5px">
              <h6>Followup date : {{followup.lastDate}}</h6>
              <div>{{followup.remarks}}</div>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
        edit: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,
      dialoghis: false,
      dateModel: false,

      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,

      itemAdded: [],


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },

      headers: [
        { text: "#", value: "#" },
        { text: "Country", value: "countryName" },
        { text: "Universty", value: "universityName" },
        { text: "Course", value: "courseName" },
        { text: "Level", value: "levelName" }/* ,
        { text: "Remove", value: "remove" } */
      ],

      valid: true,
      roleType: sessionStorage.roles,

      nature: ["Training", "Application process"],
      selectedNature: null,

      source: ["Facebook", "Justdial", "Sulekha", "Google", "Instagram", "Website", "Reference std", "Reference bp", "Reference emp", "Data calling", "Filed campaign", "Campus activities", "Leaflets" ],
      selectedSource: null,

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Leads",
          disabled: false,
          to: "/lead"
        },
        {
          text: "View Lead",
          disabled: true,
          to: "/createLead"
        }
      ],

      country: null,
      selectedCountry: null,

      university: null,
      selectedUniversity: null,

      course: null,
      selectedCourse: null,

      level: null,
      selectedLevel: null,

      user: null,
      selectedUser: null,

      form: {
      },

      form1: {
        countryName: null
      },
      form2: {
        universityName: null
      },
      form3: {
        courseName: null
      },
      form4: {
        levelName: null
      },
      formf: {
        remarks: null,
        nextFollowupDate: null
      },
      forma: {
      }
    };
  },

  mounted() {
    this.getData();
    this.getData1();
      this.getData2();
      this.getData3();
      this.getData4();

      this.axios
        .get(config.API + "CounsellorList", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.user = res.data;
        });
    },

  methods: {
    getData() {
      this.axios
      .get(config.API + `Leads/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.selectedNature = res.data.nature;
        this.selectedSource = res.data.source;
        this.selectedLevel = res.data.levelId;
        this.selectedUser = res.data.allotedTo;
        this.itemAdded = res.data.detail;
      });
    },
    getData1() {
      this.axios
        .get(config.API + "Countries", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.country = res.data;
          this.getData1();
        });
    },
    
    getData2() {
      this.axios
        .get(config.API + "Universities", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.university = res.data;
          this.getData2();
        });
    },
        
    getData3() {
      this.axios
        .get(config.API + "Courses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.course = res.data;
          this.getData3();
        });
    },

    getData4() {
      this.axios
        .get(config.API + "Levels", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.level = res.data;
          this.getData4();
        });
    },
        
    submit1() {
    if (this.$refs.form1.validate()) {
      this.axios
          .post(
            config.API + "Countries",
            {
              countryName: this.form1.countryName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Country successfully added");
            this.form1.countryName = null;
            this.dialog1 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit2() {
    if (this.$refs.form2.validate()) {
      this.axios
          .post(
            config.API + "Universities",
            {
              universityName: this.form2.universityName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("University successfully added");
            this.form2.universityName = null;
            this.dialog2 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit3() {
    if (this.$refs.form3.validate()) {
      this.axios
          .post(
            config.API + "Courses",
            {
              courseName: this.form3.courseName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Course successfully added");
            this.form3.courseName = null;
            this.dialog3 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit4() {
    if (this.$refs.form4.validate()) {
      this.axios
          .post(
            config.API + "Levels",
            {
              levelName: this.form4.levelName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Level successfully added");
            this.form4.levelName = null;
            this.dialog4 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },
    back() {
      this.$router.go(-1);
    },

    close() {
      this.dialog = false;
      this.selectedCountry = null;
      this.selectedUniversity = null;
      this.selectedCourse = null;
      this.selectedLevel = null;
    },
    deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
          this.axios
          .delete(config.API + `LeadDetails/${item.ids}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            const index = this.itemAdded.indexOf(item);
            this.itemAdded.splice(index, 1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    save() {
        if(this.selectedCountry != null && this.selectedUniversity != null && this.selectedCourse != null && this.selectedLevel != null) {
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               levelId: JSON.parse(this.selectedLevel.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName,
               levelName: this.selectedLevel.levelName
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _countryId = this.itemAdded[i].countryId;
                    let _universityId = this.itemAdded[i].universityId;
                    let _courseId = this.itemAdded[i].courseId;
                    let _levelId = this.itemAdded[i].levelId;

                    if(_countryId == this.selectedCountry.id && _universityId == this.selectedUniversity.id && _courseId == this.selectedCourse.id && _levelId == this.selectedLevel.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               levelId: JSON.parse(this.selectedLevel.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName,
               levelName: this.selectedLevel.levelName
              });

              this.close();
               }
            }
        }
        else {
            this.$toaster.error(`Please select one!!`);
        }
        
      },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Leads/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              email: this.form.email,
              nature: this.selectedNature,
              source: this.selectedSource,
              document: this.form.document,
              documentType: this.form.documentType,
              notes: this.form.notes,

              leadDetails: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Lead successfully added");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSave() {
    if (this.$refs.formf.validate()) {
      this.btnSave = true;
         this.axios
          .post(
            config.API + "Followups",
            {
              leadId: JSON.parse(this.form.id),
              remarks: this.formf.remarks,
              nextFollowupDate: new Date(this.formf.nextFollowupDate)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.$toaster.success("Followup successfully added");
            this.$refs.formf.reset();
            this.getData();
            this.btnSave = false;
          })
          .catch(err => {
            console.log(err.message);
            this.btnSave = false;
          });
    }
    },

    onSaveA() {
    if (this.$refs.forma.validate()) {
      this.btnSave = true;
      this.axios
          .put(
            config.API + `LeadAllot/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              allotedTo: this.selectedUser
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.$toaster.success("Lead Allotement Successful");
            this.$refs.forma.reset();
            this.getData();
            this.btnSave = false;
          })
          .catch(err => {
            console.log(err.message);
            this.btnSave = false;
          });
    }
    },

    onEdit() {
      this.$router.push(`/editLead/${this.$route.params.id}`);
    },
  }
};
</script>

<style>
.bckgrnds {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.hvr:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
